export default "__VITE_ASSET__PBfDd4GF__"